var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fal",class:_vm.sportIcon(_vm.sport),attrs:{"title":_vm.sport}})
}
var staticRenderFns = []

export { render, staticRenderFns }